import PropTypes from 'prop-types';
import React from 'react';
import MokaArrow from 'assets/images/start-using-moka-arrow.png';
import styles from './Breadcrumb.css';

class Breadcrumb extends React.PureComponent {
  render() {
    return (
      <div className={styles.breadcrumbContainer}>
        <p>
          {this.props.locations.map((curCrumb, i) => (
            <label key={i}>
              {this.breadcrumbWithLink(i, curCrumb)} {this.arrow(i)}{' '}
            </label>
          ))}
        </p>
      </div>
    );
  }

  breadcrumbWithLink(index, curCrumb) {
    if (index === 0) {
      return (
        <a
          href="/apps/app-market"
          onClick={() => this.props.onClickBreadcrumb(index, curCrumb)}
        >
          {curCrumb}
        </a>
      );
    }
    return curCrumb;
  }

  arrow(index) {
    if (this.props.locations && index < this.props.locations.length - 1) {
      return (
        <span style={{ margin: '0px 10px' }}>
          <img style={{ width: '5px', height: '8px' }} src={MokaArrow} />
        </span>
      );
    }
  }
}

Breadcrumb.propTypes = {
  onClickBreadcrumb: PropTypes.func,
};

Breadcrumb.defaultProps = {
  onClickBreadcrumb() {
    /* no op */
  },
};

export default Breadcrumb;
